import { useQuery } from "@tanstack/react-query";
import { apiClient } from "./api-client";

export const clientInvoiceKeys = {
  all: () => ["client-invoices"],
  list: (params) => ["client-invoices", "list", params],
};

/**
 * @param {{
 *   page?: number;
 *   limit?: number;
 *   invoiceKind?: string;
 *   provider?: string;
 *   isPaid?: boolean;
 * }} params
 */
export function fetchClientInvoices({
  page = 1,
  limit = 10,
  invoiceKind,
  provider,
  isPaid,
} = {}) {
  const params = { page, limit };
  if (invoiceKind) params.invoiceKind = invoiceKind;
  if (provider) params.provider = provider;
  if (isPaid !== undefined && isPaid !== null && isPaid !== "") {
    params.isPaid = isPaid;
  }
  return apiClient({
    url: "users/client/invoices",
    method: "GET",
    params,
  });
}

function parseIsPaidParam(value) {
  if (value === "" || value == null) return undefined;
  if (value === true || value === "true") return true;
  if (value === false || value === "false") return false;
  return undefined;
}

/**
 * @param {{
 *   page?: number;
 *   limit?: number;
 *   invoiceKind?: string;
 *   provider?: string;
 *   isPaid?: boolean | string;
 * }} filters
 * @param {{ enabled?: boolean }} [options]
 */
export function useClientInvoicesQuery(filters, options) {
  return useQuery({
    queryKey: clientInvoiceKeys.list(filters),
    queryFn: () =>
      fetchClientInvoices({
        page: filters.page,
        limit: filters.limit,
        invoiceKind: filters.invoiceKind || undefined,
        provider: filters.provider || undefined,
        isPaid: parseIsPaidParam(filters.isPaid),
      }),
    placeholderData: (prev) => prev,
    enabled: options?.enabled !== false,
  });
}

export function extractClientInvoiceRows(payload) {
  if (!payload) return [];
  const rows = Array.isArray(payload.data) ? payload.data : [];
  return rows.filter((row) => row?.invoiceKind !== "refund");
}

export function extractClientInvoiceTotal(payload) {
  if (payload == null) return 0;
  const n = payload.total;
  if (typeof n === "number" && !Number.isNaN(n)) return n;
  return extractClientInvoiceRows(payload).length;
}
